import { Box, List, ListItemButton, ListItemText, Typography } from '@mui/material';
import Info from 'components/Info';
import React from 'react';

type TemplateItem = {
    st_template: string;
    title: string;
    content: string;
    description: string;
};

type EditorLike = {
    insertContent: (content: string) => void;
};

type SidebarTemplatesProps = {
    templates: TemplateItem[];
    editor?: EditorLike | null;
};

const SidebarTemplates = ({ templates = [], editor }: SidebarTemplatesProps) => {
    const insertTemplate = (template: TemplateItem) => {
        const content = template.content;

        if (!content || !editor) {
            return;
        }

        editor.insertContent(content);
    };

    return (
        <Box>
            {templates.length === 0 && (
                <Typography variant="body2" color="text.secondary">
                    No quick-fill options available.
                </Typography>
            )}

            {templates.length > 0 && (
                <List dense disablePadding>
                    {templates.map((template, index) => (
                        <ListItemButton
                            key={template.st_template}
                            onClick={() => insertTemplate(template)}
                            disabled={!editor}
                        >
                            <ListItemText
                                primary={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>{template.title}</Box>
                                }
                                secondary={!editor ? 'Editor is not ready yet' : null}
                            />
                            <Info sx={{ fontSize: '16px' }} renderHtml>
                                {template.content}
                            </Info>
                        </ListItemButton>
                    ))}
                </List>
            )}
        </Box>
    );
};

export default SidebarTemplates;
